import {ShowContract} from './show-contract';

export default ShowContract;
